import { Routes } from '@angular/router';
import { Complete } from './components/complete/complete';
import { ExclusionComplete } from './components/exclusion-complete/exclusion-complete';
import { File } from './components/file/file';
import { Home } from './components/home/home';
import { CourtDocuments } from './components/court-documents/court-documents';
import { FAQ } from './components/faq/faq';
import { Notice } from './components/notice/notice';
import { ClaimForm } from './components/claim-form/claim-form';
import { ExclusionRequest } from './components/exclusion-request/exclusion-request';
// import { Exclusion } from './components/exclusion/exclusion';
import { Contact } from './components/contact/contact';
import { HomeEspanol } from './components/home-espanol/home-espanol';
import { Login } from './components/login/login';
import { NoticedFile } from './components/file-noticed/file-noticed';


export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'file', component: File },
  { path: 'file-noticed', component: NoticedFile },
  { path: 'complete', component: Complete },
  { path: 'exclusion-complete', component: ExclusionComplete },
  { path: 'home', component: Home },
  { path: 'home-espanol', component: HomeEspanol },
  { path: 'court-documents', component: CourtDocuments },
  { path: 'faq', component: FAQ },
  { path: 'notice', component: Notice },
  { path: 'claim-form', component: ClaimForm },
  { path: 'exclusion-request', component: ExclusionRequest },
  // { path: 'exclusion', component: Exclusion },
  { path: 'contact', component: Contact },
  { path: 'login', component: Login },

  { path: '**', redirectTo: 'home' },

];
